import React, { useMemo } from 'react';
import {
  ActivityAssociation,
  File,
  GroupEntityLabelKey,
  useGroupEntityLabel,
} from 'v2/models';
import { groupAssociations } from 'v2/utils/activityUtils';
import ActivityAssociationWithoutContent from './ActivityAssociationWithoutContent/ActivityAssociationWithoutContent';
import ActivityAssociationCategory from './ActivityAssociationCategory/ActivityAssociationCategory';

export interface GroupedAssociations {
  type: string;
  label: string;
  data: ActivityAssociation[];
}

export interface ActivityAssociationsTypeContentProps {
  currentAssociationType: GroupEntityLabelKey;
  localAssociations: Array<ActivityAssociation>;
  checkedAssociations: Array<ActivityAssociation>;
  file: File | undefined;
  activityType?: string;
  checkBoxChanged: (
    isChecked: boolean,
    association: ActivityAssociation
  ) => void;
}

const ActivityAssociationsTypeContent = ({
  currentAssociationType,
  localAssociations,
  checkedAssociations,
  file,
  activityType,
  checkBoxChanged,
}: ActivityAssociationsTypeContentProps) => {
  const groupEntityLabel = useGroupEntityLabel();
  const viewableAssociations = localAssociations.filter(
    (association) =>
      association.is_viewable === true || association.is_viewable === undefined
  );
  const label = groupEntityLabel[currentAssociationType];

  const groupedAssociations = useMemo(
    () => groupAssociations(groupEntityLabel, viewableAssociations),
    [viewableAssociations]
  );

  const currentAssociationGroup = groupedAssociations.filter(
    (group) =>
      currentAssociationType === 'ALL' || group.type === currentAssociationType
  );

  return (
    <div className="flex flex-row">
      {viewableAssociations.length === 0 ? (
        <ActivityAssociationWithoutContent label={label} />
      ) : (
        currentAssociationGroup.map((group, index) => {
          if (currentAssociationType !== 'ALL' && group.data.length === 0) {
            return (
              <ActivityAssociationWithoutContent key={index} label={label} />
            );
          } else if (group.data.length) {
            return (
              <ActivityAssociationCategory
                key={index}
                label={group.label}
                associationList={group.data}
                checkedAssociations={checkedAssociations}
                file={file}
                activityType={activityType}
                checkBoxChanged={checkBoxChanged}
              />
            );
          } else {
            return null;
          }
        })
      )}
    </div>
  );
};

export default ActivityAssociationsTypeContent;
